import React, { Component } from "react";
import { Checkbox, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Fade, FormControlLabel, TextField } from "@material-ui/core";
import { connect, ConnectedProps } from "react-redux";
import { v4 as uuidv4 } from 'uuid';
import { getDefaultFuelGasComposition } from "../../configuration";
import { UNIT } from "../../interfaces/IComponent";
import { FUELGAS_STATUS, IFuelGas } from "../../interfaces/IFuelGas";
import { RootState } from "../../reducers/rootReducer";
import { addFuelGas } from "../../slices/fuelGasSlice";
import { checkFuelgasName } from "../../services/fuelgasServices";
import { AuthContextProps, withAuth } from "react-oidc-context";
import { getToken } from "../../utilities/helperFunctions";
interface IAddFuelGasProps {
    fuelGas: IFuelGas | undefined
}

interface OIDCAuth {
    auth?: AuthContextProps
 }

const mapStateToProps = (state: RootState) => {
    return {
        currentFurnaceId: state.scenarioSimulator.currentFurnaceId,
        fuelGases: state.fuelGas.fuelGases
    };
};

const mapDispatchToProps = dispatch => {
    return {
        addFuelGas: (newFuelGas: IFuelGas) => dispatch(addFuelGas(newFuelGas)),
    };
};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

type IAddFuelGasReduxProps = PropsFromRedux & IAddFuelGasProps & OIDCAuth;

type IAddFuelGasState = {
    showDialog: boolean;
    name: string;
    is_public: boolean;
    isNameAvailable: boolean;
    nameErrorMessage: string;
    showLoading: boolean;
}
class AddFuelGas extends Component<IAddFuelGasReduxProps, IAddFuelGasState>{

    constructor(props) {
        super(props);

        this.state = {
            showDialog: false,
            name: "",
            is_public: true,
            isNameAvailable: false,
            nameErrorMessage: "",
            showLoading: false,
        }
    }

    toggleShowDialog() {
        this.setState({
            showDialog: !this.state.showDialog,
            name: "",
            isNameAvailable: false,
            nameErrorMessage: ""
        })
    }

    handleNameInput(event) {
        this.setState({
            name: event.target.value.toUpperCase()
        })
    }

    addNewFuelGas = async () => {
        if (!!this.state.name?.trim() && this.state.name !== "DEFAULT_DEMO") {
            this.setState({
                showLoading: true,
            })

            let setName = this.state.is_public === true ? this.state.name.trim() + "(PUBLIC)" : this.state.name.trim();

            let newFuelGas: IFuelGas = {
                id: uuidv4(),
                name: setName,
                unit: UNIT.MOL,
                components: getDefaultFuelGasComposition(),
                status: FUELGAS_STATUS.UNCOMPUTED,
                error_message: "",
                O2BridgeWall: -1,
                Pressure: -1,
                Temperature: -1,
                signature: "",
                is_public: this.state.is_public,
                is_display_leave_popup: false
            }
            newFuelGas = JSON.parse(JSON.stringify(newFuelGas));
            newFuelGas.components.forEach(component => {
                component.value = 0;
            });
            try {
                let isNameInRedux = this.props.fuelGases.some(fuelgas => fuelgas.name === newFuelGas.name);
                if (isNameInRedux) {
                    this.setState({
                        isNameAvailable: true,
                        nameErrorMessage: "Name already exist!",
                        showLoading: false,
                    })
                } else {
                    const accessToken = await getToken(this.props.auth);
                    let isNameAvailable = await checkFuelgasName(newFuelGas, accessToken);

                    if (isNameAvailable.status) {
                        this.setState({
                            isNameAvailable: true,
                            nameErrorMessage: !!isNameAvailable.message ? isNameAvailable.message : "Name already exist!",
                            showLoading: false,
                        })
                    } else {
                        this.props.addFuelGas(newFuelGas);
                        this.toggleShowDialog();
                        this.setState({
                            showLoading: false,
                        })
                    }
                }
            } catch (error) {
                // Api error hendaling 
                this.setState({
                    isNameAvailable: true,
                    showLoading: false,
                    nameErrorMessage: "Oops somthing went to wrong!"
                })
            }

        } else {
            this.setState({
                isNameAvailable: true,
                nameErrorMessage: "Please enter a name!",
                showLoading: false,
            })
        }
    }

    handleChangeIsPublic(event) {
        this.setState({
            is_public: !this.state.is_public
        })
    }

    render() {
        return (
            <div className="control-header element">
                <button
                    className="button"
                    onClick={() => this.toggleShowDialog()}
                    disabled={!!this.props.fuelGas && !this.props.fuelGas.is_saved && !this.props.fuelGas.id.startsWith("_DEFAULT")}
                >
                    Add
                </button>
                <Dialog open={this.state.showDialog} onClose={() => this.toggleShowDialog()} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Add new fuel gas</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            To add a new fuel gas, please provide the following information:
                        </DialogContentText>
                        <TextField
                            autoFocus
                            margin="dense"
                            id="name"
                            label="Name"
                            type="text"
                            fullWidth
                            defaultValue={this.state.name}
                            value={this.state.name}
                            onChange={(event) => this.handleNameInput(event)}
                            helperText={this.state.nameErrorMessage}
                            error={this.state.isNameAvailable}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.is_public}
                                    onChange={(event) => this.handleChangeIsPublic(event)}
                                    name="isPublic"
                                    value={this.state.is_public}
                                    color="primary"
                                />
                            }
                            label="Is Public?"
                        />
                    </DialogContent>
                    <DialogActions>
                        <button className="button" onClick={() => this.toggleShowDialog()}>
                            Cancel
                        </button>
                        <button className="button" onClick={() => this.addNewFuelGas()} disabled={this.state.showLoading}>
                            Add {this.state.showLoading === true && (
                                <Fade
                                    in={this.state.showLoading}
                                    style={{
                                        transitionDelay: this.state.showLoading ? '800ms' : '0ms',
                                    }}
                                    unmountOnExit
                                >
                                    <CircularProgress size={11} />
                                </Fade>
                            )}
                        </button>
                    </DialogActions>
                </Dialog>
            </div>
        );
    }

};

export default withAuth(connector(AddFuelGas));